import React, { useState } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import {
    InformationChip,
    ItemActions,
    type L2DPalette,
    LinkButton,
} from '@europrocurement/flexy-components';

interface PrescripteurOffreSectionProps {
    prescripteur: {
        id: number;
        raisonSociale: string;
        codeComptable: string;
        urlToDetails?: string;
    };
    offre: { libelle: string };
    palette: L2DPalette;
    source: 'BACK' | 'FRONT';
}

export const PrescripteurOffreSection: React.FunctionComponent<PrescripteurOffreSectionProps> =
    function ({ prescripteur, offre, palette, source = 'FRONT' }) {
        const [prescHovered, setPrescHovered] = useState(false);

        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '16px' }}>
                <Typography
                    variant="l2dbodys"
                    color={palette.text.primary}
                >
                    Prescripteur:
                </Typography>

                <Box
                    sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                    onMouseEnter={() => setPrescHovered(true)}
                    onMouseLeave={() => setPrescHovered(false)}
                >
                    {prescripteur.urlToDetails ? (
                        <Tooltip title="Accéder à la fiche prescripteur">
                            <span style={{ display: 'inline-flex' }}>
                                <LinkButton
                                    target="_blank"
                                    to={prescripteur.urlToDetails}
                                    onClick={() => {}}
                                    wrapperSx={{
                                        backgroundColor: palette.grey[100],
                                        '&:hover': {
                                            backgroundColor: palette.grey[200],
                                            color: palette.grey[900],
                                        },
                                        fontWeight: 500,
                                        color: palette.grey[700],
                                        padding: '6px 8px',
                                    }}
                                    label={prescripteur.raisonSociale}
                                />
                            </span>
                        </Tooltip>
                    ) : (
                        <Typography
                            variant="l2dbodys"
                            color="text.gris70"
                            sx={{ fontWeight: 500 }}
                        >
                            {prescripteur.raisonSociale}
                        </Typography>
                    )}

                    <ItemActions
                        copyValue={prescripteur.raisonSociale}
                        visible={prescHovered}
                        slideDirection="left"
                    />
                </Box>

                <Typography
                    variant="l2dbodys"
                    color="text.gris50"
                >
                    ({prescripteur.codeComptable})
                </Typography>

                {source === 'BACK' ? (
                    <InformationChip
                        label={<Typography variant="l2dbodys">{offre?.libelle}</Typography>}
                        icon={['fasl', 'star-circle']}
                        color={palette.grey[600]}
                    />
                ) : null}
            </Box>
        );
    };
